export default {
  colors: {
    green: '#2FB55F',
    purple: '#7458B1',
    blue: '#3DAAD6',
    red: '#EB3D44',
    grey: '#606B7E'
  }
};
